/* eslint-disable react-hooks/exhaustive-deps */
// noinspection JSIgnoredPromiseFromCall

import React, { useEffect, useState } from 'react';
import { SFuncModal } from 'shj-components'
import { Button, Col, Form, Input, message, Row, Select, Switch } from 'antd';
import type { ConfigItem, EnumDescription } from '../interface';

export interface ConfigModalProp {
  title: string;
  callback: (config: ConfigItem) => void;
  record: ConfigItem;
  configItemTypes: EnumDescription[];
  configKeys: string[];
}

export interface ConfigModalDomProp {
  callback: (config: ConfigItem) => void;
  record: ConfigItem;
  onClose: () => void;
  configItemTypes: EnumDescription[];
  configKeys: string[];
}

const ConfigModalDom = (props: ConfigModalDomProp) => {
  const { onClose, callback, record, configItemTypes, configKeys } = props;
  const [form] = Form.useForm();
  const { setFieldsValue } = form;

  const [data, setData] = useState<Record<string, any>>({});

  const updateData = (newData: ConfigItem) => {
    setData(newData);
    setFieldsValue(newData);
  };

  const initFn = () => {
    updateData(record);
  };

  useEffect(() => {
    initFn();
  }, []);

  // 提交
  const onFinish = () => {
    form.validateFields().then((values: ConfigItem) =>{
        const config = { ...values, ...data };
        if (configKeys.includes(config.configKey)) {
          message.error('配置Key重复');
          return;
        }
        if (callback) {
          callback(config);
        }
        onClose();
    })
  };

  const onChange = (val: ConfigItem) => {
    setData({
      ...data,
      ...val,
    });
  };

  return (
    <SFuncModal.Content
    cancelText="取消"
      onCancel={onClose}
      onOk={onFinish}
    >
      <Form
        form={form}
        autoComplete="off"
        onValuesChange={onChange}
        labelAlign={'right'}
        labelCol={{ span: 4 }}
      >
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item
              label="配置Key"
              name="configKey"
              rules={[
                { required: true, message: '配置Key不能为空' },
                () => ({
                  validator(_, value) {
                    if (!configKeys.includes(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('配置Key重复'));
                  },
                }),
              ]}
            >
              <Input placeholder="请输入配置Key" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item label="配置名称" name="configName" rules={[{ required: true, message: '配置名称不能为空' }]}>
              <Input placeholder="请输入配置名称" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item label="必填项" name="required">
              <Switch checkedChildren="是" unCheckedChildren="否" checked={data && data.required} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item label="类型" name="type" rules={[{ required: true, message: '请选择类型' }]}>
              <Select style={{ width: 120 }} placeholder="请选择类型">
                {configItemTypes &&
                  configItemTypes.map((item) => (
                    <Select.Option key={item.key} value={item.key}>
                      {item.value}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {/* <Row>
          <Col span={24} style={{ textAlign: 'right' }}>
            <Button htmlType="button" onClick={onClose} style={{ margin: '0 8px' }}>
              关闭
            </Button>
            <Button type="primary" style={{ marginLeft: '15px' }} htmlType="submit">
              保存
            </Button>
          </Col>
        </Row> */}
      </Form>
    </SFuncModal.Content>
  );
};

export function configModal(props: ConfigModalProp) {
  const { callback, title, record, configItemTypes, configKeys } = props;
  let dialog: any = 0;
  const onClose = () => {
    (dialog as any)?.destroy();
  };
  dialog = SFuncModal({
    width: 600,
    vanish: true,
    title: `${title}`,
    content: (
      <ConfigModalDom
        onClose={onClose}
        callback={callback}
        record={record}
        configItemTypes={configItemTypes}
        configKeys={configKeys}
      />
    ),
  });

  return dialog;
}
